import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { MainComponent } from './main/main.component';

const routes: Routes = [
  // { path: '', component: ComingSoonComponent }
  { path: '', component: MainComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    ComingSoonComponent,
    MainComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      routes
    )
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/dearmom/Sites/portfolio/src/app/app.module.ts